import PhoneVerification from './phoneVerification'
import RichTextView from './richTextView'
import ListingSellerRepresentativeCard from './listingSellerRepresentativeCard'

/**
 * I'd prefer to export * here but there's a weird issue with
 * /babel-plugin-rewire which is causing the tests to fail when you use
 * export * from './applicationNotifiers'.  Not sure it was ever resolved.
 *
 * https://github.com/speedskater/babel-plugin-rewire/issues/78
 */
export {
  ApplicationNotificationsProvider,
  ApplicationNotificationsConsumer,
  useApplicationNotifications,
  withApplicationNotificationsContext,
  getApplicationNotificationsBridgeContext,
  NOTIFICATION_ROLES,
  DEFAULT_NOTIFICATION_OPTIONS,
  getNullApplicationNotifications,
  MockApplicationNotificationsProvider,
} from './applicationNotifiers'

export {
  ApplicationThemeProvider,
  ApplicationThemeConsumer,
  useApplicationTheme,
  withApplicationTheme,
  ProductLine,
} from './applicationTheme'

export * from './elementals'
export * from './formFields'
export * from './layouts'
export * from './overlays'
export * from './photoManagement'
export * from './reduxFormFields'
export * from './listing'
export * from './closing'
export * from './property/propertySaveIndicator'
export * from './pibi'
export * from './onlineAuction/sealedBid'
export * from './downloadLink'
export { default as ClosingStandardWorkflow } from './closingStandardWorkflow'
export { PhoneVerification, RichTextView, ListingSellerRepresentativeCard }
